var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowReadStatus),expression:"isShowReadStatus"}],class:{
    'message-label': true,
    unread: _vm.isUseUnreadStyle,
    'finger-point': _vm.isHoverFingerPointer,
  },on:{"click":_vm.openReadUserPanel}},[_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }